"use strict";

/**
 * Mobile header banner
 */
;
(function () {
  // Call "onPageLoad" when page loaded and "Flix" object prepared
  document.addEventListener('flix:load', onPageLoad);
  // refresh banners after new related videos loaded
  document.addEventListener('flix:additional-related', onPageLoad);

  /**
   * Check if this ad should be shown
   * @returns boolean
   */
  function isEnabled() {
    return Flix.ads.enabled
    /** Only on mobile */ && FlixUtils.isMobile();
  }
  ;

  /**
   * Main logic
   */
  function onPageLoad() {
    if (!isEnabled()) {
      return;
    }
    var el = document.querySelector('#bannerBlock_head');
    if (!el) {
      return;
    }
    el.innerHTML = '<div class="ad-logo">Ad</div>';
    FlixUtils.renderBannerAd(getZoneId(), el, 'eas6a97888e38', 'ad_error_header');
  }
  ;
  function getZoneId() {
    return Flix.isTna() ? '4297268' : '4297264';
  }
})();